import { chatApi } from "./chatClient";
import type { CursorPage, User } from "./types";

export interface ListUsersParams {
  search?: string;
  cursor?: string | null;
  limit?: number;
}

function qs(params: ListUsersParams): string {
  const entries = Object.entries(params as Record<string, unknown>).filter(
    ([, v]) => v !== undefined && v !== null && v !== "",
  ) as [string, string | number][];
  return entries.length ? `?${new URLSearchParams(entries.map(([k, v]) => [k, String(v)]))}` : "";
}

export const usersService = {
  list: (params: ListUsersParams = {}) =>
    chatApi.get<CursorPage<User>>(`/users/${qs(params)}`),

  retrieve: (sub: string) => chatApi.get<User>(`/users/${sub}/`),

  me: () => chatApi.get<User>(`/users/me/`),
};
